import $ from 'jquery';
import 'jquery-sticky';
import ScrollWatcher from 'scroll-watcher';

// jQuery plugin for sticky menu from http://stickyjs.com
Drupal.behaviors.troaxSegmentStickyMenu = {
  attach() {
    // Apply to sub-menu-sticky on selected pages
    $('.sub-menu-sticky')
      .once('troaxSegmentStickyMenu')
      .each((index, element) => this.segmentStickyMenu(element));
  },

  segmentStickyMenu(element) {
    const menuItem = $('.segment-nav .menu__list-wrapper li');
    const mq = window.matchMedia('(min-width: 1024px');
    if (mq.matches) {
      $(element).sticky({
        topSpacing: 0,
        getWidthFrom: '.sub-menu-sticky',
        responsiveWidth: true,
        zIndex: 2,
      });
    }

    /* eslint-disable */
    $(menuItem).on('click', function() {
      /* remove classname 'active' from all li who already has classname
      'active' & add to the link that has click */
      if (menuItem.hasClass('active')) {
        menuItem.removeClass('active');
      }

      $(this).addClass('active');
    });

    const scroll = new ScrollWatcher();
    $("div[id*='section']").each(function() {
      scroll.watch(`#${this.id}`)
        .on("enter", function (evt) {
          $(`a[href="#${evt.target.id}"]`).parent('li').addClass('active');
        })
        .on("exit", function (evt) {
          $(`a[href="#${evt.target.id}"]`).parent('li').removeClass('active');
        });
    });
    /* eslint-enable */
  },
};
